import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateIglooPin } from './get-igloo-pin'

// Note: 404s if the resident has no active PIN — the caller only renders Resend
// while a PIN is issued, so that path is a race, not a normal state.
const resendIglooPinEmail = async (clientId: string) => {
  const response = await authAPI.post(`/igloowork/${clientId}/pin/resend`)
  return response.data
}

export const useResendIglooPinEmail = (clientId: string) => {
  const invalidate = useInvalidateIglooPin(clientId)
  return useMutation({
    mutationFn: () => resendIglooPinEmail(clientId),
    onSuccess: invalidate,
  })
}
